import { render, staticRenderFns } from "./progress-indicator.vue?vue&type=template&id=5089a3bc&scoped=true"
import script from "./progress-indicator.vue?vue&type=script&lang=ts"
export * from "./progress-indicator.vue?vue&type=script&lang=ts"
import style0 from "./progress-indicator.vue?vue&type=style&index=0&id=5089a3bc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089a3bc",
  null
  
)

export default component.exports